import { useState, useEffect, useMemo } from 'react';
import {
  Box,
  FormControl,
  FormGroup,
  Typography,
  Grid
} from '@material-ui/core';
import React from 'react';

const months = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const getDaysInMonth = (monthIndex, year) => {
  if (monthIndex === 1) return 29; // febrero
  const daysPerMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return daysPerMonth[monthIndex];
};

const DayItem = React.memo(function DayItem({ monthIndex, day, selected, onToggle }) {
  return (
    <Box
      onClick={() => onToggle(monthIndex, day)}
      style={{
        width: 32,
        height: 32,
        borderRadius: 6,
        border: "2px solid #1976d2",
        backgroundColor: selected ? "#1976d2" : "white",
        color: selected ? "white" : "#1976d2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        userSelect: "none",
        fontSize: "0.9rem",
        margin: "4px"
      }}
    >
      {day}
    </Box>
  );
});

const TdmFilterOptions = ({ varState, setVarState }) => {
  const [monthDayMap, setMonthDayMap] = useState({});
  const year = new Date().getFullYear();

  const daysByMonth = useMemo(() => {
    return months.map((_, i) =>
      Array.from({ length: getDaysInMonth(i, year) }, (_, idx) => idx + 1)
    );
  }, [year]);

  useEffect(() => {
    if (varState?.a?.d) {
      setMonthDayMap(parseYearDays(varState.a.d));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const result = formatYearDays(monthDayMap);
      setVarState(v => ({
        ...v,
        a: {
          ...v.a,
          d: result
        }
      }));
    }, 50);

    return () => clearTimeout(timeout);
  }, [monthDayMap, setVarState]);

  const handleToggleDay = (monthIndex, day) => {
    setMonthDayMap(prev => {
      const currentDays = prev[monthIndex] || [];
      const exists = currentDays.includes(day);

      return {
        ...prev,
        [monthIndex]: exists
          ? currentDays.filter(d => d !== day)
          : [...currentDays, day]
      };
    });
  };

  const formatYearDays = (data) => {
    return Object.entries(data)
      .filter(([, days]) => days.length > 0)
      .map(([month, days]) => {
        const sorted = [...days].sort((a, b) => a - b);
        const ranges = [];
        let start = sorted[0];
        for (let i = 1; i <= sorted.length; i++) {
          if (sorted[i] !== sorted[i - 1] + 1) {
            const end = sorted[i - 1];
            ranges.push(start === end ? `${start}` : `${start}-${end}`);
            start = sorted[i];
          }
        }
        return `${parseInt(month) + 1}(${ranges.join(',')})`;
      }).join('');
  };

  const parseYearDays = (str) => {
    const regex = /(\d+)\(([^)]*)\)/g;
    let match;
    const result = {};
    while ((match = regex.exec(str)) !== null) {
      const month = parseInt(match[1], 10) - 1;
      const content = match[2];
      let days = [];
      content.split(',').forEach(part => {
        if (part.includes('-')) {
          const [start, end] = part.split('-').map(Number);
          for (let i = start; i <= end; i++) days.push(i);
        } else if (part) {
          days.push(Number(part));
        }
      });
      result[month] = days;
    }
    return result;
  };

  return (
    <Box mt={2} paddingLeft={6} paddingRight={6}>
      <Grid container spacing={6} alignItems="stretch">
        {months.map((mes, monthIndex) => (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            key={monthIndex}
            style={{ display: 'flex' }}
          >
            <Box
              border={1}
              borderColor="grey.300"
              borderRadius={2}
              p={2}
              style={{ height: '100%', width: '100%' }}
            >
              <Typography variant="subtitle2" gutterBottom>{mes}</Typography>

              <FormControl component="fieldset">
                <FormGroup row>
                  {daysByMonth[monthIndex].map((day) => (
                    <DayItem
                      key={day}
                      monthIndex={monthIndex}
                      day={day}
                      selected={monthDayMap[monthIndex]?.includes(day) || false}
                      onToggle={handleToggleDay}
                    />
                  ))}
                </FormGroup>
              </FormControl>

            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TdmFilterOptions;
